import React from "react";
import { cn } from "@/lib/utils";

/**
 * Benchmark vs Marketing source badge/pill. Never relies on colour alone —
 * always shows the label + a coloured dot.
 */
export function DataSourceBadge({ source = "benchmark", className, testId }) {
  const isBench = source === "benchmark";
  return (
    <span
      data-testid={testId || (isBench ? "source-benchmark-badge" : "source-marketing-badge")}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-medium",
        isBench
          ? "border-[hsl(var(--source-benchmark)/0.35)] bg-[hsl(var(--source-benchmark)/0.10)] text-[hsl(var(--source-benchmark))]"
          : "border-[hsl(var(--source-marketing)/0.35)] bg-[hsl(var(--source-marketing)/0.10)] text-[hsl(var(--source-marketing))]",
        className
      )}
    >
      <span
        className="h-1.5 w-1.5 rounded-full"
        style={{ background: `hsl(var(--source-${isBench ? "benchmark" : "marketing"}))` }}
      />
      {isBench ? "Benchmark" : "Marketing"}
    </span>
  );
}

export function DataSourceLegend({ className }) {
  return (
    <div className={cn("flex items-center gap-2 text-xs text-muted-foreground", className)} data-testid="data-source-legend">
      <DataSourceBadge source="benchmark" />
      <DataSourceBadge source="marketing" />
    </div>
  );
}
